import {
  ButtonField,
  ButtonGroup,
  ButtonGroupItem,
  debounce,
  InputField,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  SearchSuggestionsWrapper,
} from "@wk/components-react16";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import HttpService from "../../../config/http.service";
import { API_USER } from "../../../config/constants";
import { Toast } from "../../../services";
import saveAs from "file-saver";

const ExportUserActionLog = ({
  isExportUserActionLog,
  setIsExportUserActionLog,
}: any) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const searchRef = useRef<SearchSuggestionsWrapper>(null);
  const suggestionList: any = useMemo(
    () => [
      {
        id: "userlist",
        type: "suggestions",
        title: "User suggestions",
        hasIcon: true,
        suggestions: [],
      },
    ],
    [],
  );
  const [suggestionUserList, setSuggestionUserList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const handleUserRequest = (origin: string) => {
    if (origin === "esc" || origin === "header" || origin === "footer") {
      clearForm();
      setIsExportUserActionLog(false);
    }
  };
  const exportLog = () => {
    if(!startDate || !endDate){
      Toast("Please select both start date and end date", "error");
      return;
    }
    let payload = {
      fromDate: startDate,
      toDate: endDate,
      username: selectedUser,
    };
    HttpService.postRequestBlob(
      API_USER.EXPORT_USER_MANAGEMENT_LOGS,
      payload,
    ).then(
      (response: any) => {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "User_Action_Log.xlsx");
      },
      (err: any) => {
        console.error("Export error:", err);
        Toast("Export failed, check console for details", "error");
      },
    );
  };

  const clearForm = () => {
    setStartDate("");
    setEndDate("");
    setSearchText("");
    setSuggestionUserList([]);
    setSelectedUser("");
  };

  // ************************* User suggestion code ************************
  const getSuggestion = useCallback(
    (text: string) => {
      setSuggestionUserList([]);
      let payload = {
        username: text,
      };
      HttpService.postRequest(API_USER.SEARCHUSER, payload).then(
        (res: any) => {
          suggestionList[0].suggestions = res.map((itm: any, index: any) => ({
            id: index,
            text: itm.username,
            uId: itm.id,
          }));
          setSuggestionUserList(suggestionList);
        },
        (err: any) => {
          Toast(err.message, "error");
        },
      );
    },
    [suggestionList],
  );

  const getSuggestionRef = useRef(getSuggestion);

  useEffect(() => {
    getSuggestionRef.current = getSuggestion;
  }, [getSuggestion]);

  const userSuggestion = useRef(
    debounce((text: string) => getSuggestionRef.current(text), 400),
  ).current;

  const getUserSuggestion = (text: string) => {
    if (text.trim() === "") return;
    userSuggestion(text);
  };
  // ************************* End of user suggestion code ************************
  const onUserSelected = (item: any) => {
    setSearchText(item.text);
    setSelectedUser(item.text);
  };

  const onClearSuggestion = () => {
    setSearchText("");
    setSelectedUser("");
    setSuggestionUserList([]);
  };

  return (
    <>
    <div className="custom-modal-body-overflow">
      <Modal
        isOpen={isExportUserActionLog}
        srLabelledBy={"modal-id-001"}
        srDescribedBy={"modal-id-002"}
        width={"600px"}
        onUserRequest={handleUserRequest}
      >
        <ModalHeader
          titleId={"modal-id-001"}
          onUserRequest={() => handleUserRequest("header")}
        >
          Export User Management Action Log
        </ModalHeader>
        <ModalBody descriptionId="modal-id-002" >
          <div className="wk-row">
            <div className="wk-col-6">
              <InputField label="Start Date" size={"small"} indicator="required">
                <input
                  type="date"
                  name="date"
                  value={startDate}
                  onChange={(event: any) => setStartDate(event.target.value)}
                />
              </InputField>
            </div>
            <div className="wk-col-6 pr-0">
              <InputField label="End Date" size={"small"} indicator="required">
                <input
                  type="date"
                  name="date"
                  value={endDate}
                  onChange={(event: any) => setEndDate(event.target.value)}
                  min={startDate}
                />
              </InputField>
            </div>
          </div>
          <div className="wk-row">
            <div
              className="wk-col-12 relative custom-overflow-inherit pr-0"
              id="search-suggestion2"
            >
              <SearchSuggestionsWrapper
                ref={searchRef}
                onInputChange={getUserSuggestion}
                onItemSelected={onUserSelected}
                options={suggestionUserList}
                size="small"
                isSearchEnabledOnEmptyInput={false}
                value={searchText}
                placeholder="Search by email id"
                onClearInput={onClearSuggestion}
              ></SearchSuggestionsWrapper>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup mode="static">
            <ButtonGroupItem slot="buttonGroupItem">
              <ButtonField size={"small"} mode={"text"}>
                <button
                  type="button"
                  id="cancel"
                  onClick={() => handleUserRequest("footer")}
                >
                  Cancel
                </button>
              </ButtonField>
            </ButtonGroupItem>
            <ButtonGroupItem slot="buttonGroupItem">
              <ButtonField size={"small"}>
                <button type="button" id="save" onClick={() => exportLog()}>
                  Export
                </button>
              </ButtonField>
            </ButtonGroupItem>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    </div>
    </>
  );
};

export default ExportUserActionLog;
